import constants from '../constants/constants.json';

export function generateHrefLang(country: string) {
  const foundCountry = constants.I18.LOCALES.find(
    locale => locale.code.toLowerCase() === country.toLowerCase()
  );

  if (foundCountry) {
    const languageTag =
      foundCountry?.languages[0] ||
      constants.I18.DEFAULT_LANGUAGE.split('-')[0];

    return `${languageTag}-${country.toLowerCase()}`;
  }
}
